import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components'
import ButtonComponent from '../../components/ButtonComponent';
import ModalDetailComponent from '../../components/ModalDetailComponent';
import DetailDataTableComponent from '../../components/DetailDatatableComponent';
import { getImageAlert } from '../../redux/action/minioAction';
import { openDetail } from '../../redux/slice/leanSlice';
import { getImageLeanList } from '../../redux/action/leanAction';
import moment from 'moment';

const TableHeadExpand = styled.th`
padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
`
const TableRowExpand = styled.td`
padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
`

const CollapseContainer = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease, transform 0.3s ease; /* Tambahkan animasi untuk max-height dan transform */
  max-height: ${(props) => (props.isOpen ? '1000px' : '0')}; /* Atur nilai maksimum tinggi untuk animasi collapse */
  transform: translateY(${(props) => (props.isOpen ? '0' : '-100%')}); /* Geser elemen ke atas saat ditutup */
`;

const CollapseContent = styled.div`
  padding: 10px;
  background-color: #f1f1f1;
`;

const DetailLaporanLean = ({siteId, waktu, startDaily}) => {
    const dispatch = useDispatch();
    const { dataFeedLean, isOpenDetailLeanPopup, date, dataReportByIdLean } = useSelector((state) => state.lean);
    const { message, type, isOpenMessage, alertData, imageData } = useSelector((state) => state.message)
    // console.log(dataReportByIdLean.date)
    const [imageDwi, setImageDwi] = useState('')
    const { user } = useSelector((state) => state.auth)
    const [page, setPage] = useState(0)
    const [sort, setSort] = useState('')
    const [select, setSelect] = useState('')
    const countPerPage = 10
    const param = {
        token: user.access_token,
        sort: sort,
        size: countPerPage,
        select: select,
        page: page,
    }
    const [isOpen, setIsOpen] = useState(false);
    const [isDivided, setIsDivided] = useState(false);

    let startValue = '';

    // Menentukan nilai yang akan digunakan berdasarkan waktu
    if (waktu === 'daily') {
      startValue = dataReportByIdLean.date
    } else if (waktu === 'monthly') {
      startValue = dataReportByIdLean.date;
    } else if (waktu === 'yearly') {
      startValue = dataReportByIdLean.date;
    }

    const handleToggleCollapse = async (index, fileName) => {
      setIsOpen((prevState) => ({
        ...prevState,
        [index]: !prevState[index],
      }));
  
      try {
        // const userImage = JSON.parse(localStorage.getItem("user"))
        await dispatch(getImageAlert({ token: param.token, fileName }));
        setIsOpen(!isOpen)
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };
    const handleCollapse = () => {
      setIsOpen(!isOpen);
    };

  //   const toggleCollapse = () => {
	// const userImage = JSON.parse(localStorage.getItem("user"))
	// dispatch(getImageAlert({token: userImage.access_token, fileName: alertData[0].fileName }))
  //   setIsOpen(!isOpen);
  // };
  useEffect(()=>{
	if(imageData !== ''){
		const reader = new FileReader();
		reader.onload = () => {
			const base64data = reader.result.split(',')[1];
			setImageDwi(base64data)
		};
		reader.onerror = () => {                
			console.error('Error reading image data');
		};
		reader.readAsDataURL(imageData);
	}
  },[imageData])

  useEffect(() => {
      dispatch(getImageLeanList({ token: param.token, siteId, waktu, [waktu === 'daily' ? 'startDaily' : waktu === 'monthly' ? 'startMonthly' : 'startYearly']: startValue }));
  }, [isOpenDetailLeanPopup]);

    const columns = [
        {
          name: 'No',
          cell: (row, index) => index + 1, //RDT provides index by default
          width: '50px'
        },
        {
          name: 'Detail File',
          selector: (row) => row.file,
        },
        {
            name: 'Action',
            cell: (row, index) => (
              <div style={{ padding: '10px 0' }}>
                <ButtonComponent
                  onClick={() => handleToggleCollapse(index, row.file)}
                  color="white"
                  backgroundColor="#3003fc"
                  backgroundHover="#2404b5"
                  spacing="5px"
                >
                  <i className="fas fa-eye" /> {`${isOpen ? 'Tutup' : 'Lihat'} Data`}
                </ButtonComponent>
              </div>
            ),
          },
      ]
    

  return (
    <ModalDetailComponent
      title="DETAIL ORANG BERSANDAR"
      show={isOpenDetailLeanPopup}
      close={() => dispatch(openDetail({ open: false, type: 'close' }))}
    >
        <div className='row'>   
            <div style={{ width: '100%', marginBottom: '20px' }}>
                <span style={{ fontSize: 'medium', fontWeight: '500', color: 'white' }}>
                    Detail Orang Bersandar
                </span>
            </div>
            <div className={isOpen ? 'col-xl-6' : 'col-xl-12'} onClick={handleCollapse}>
                  <DetailDataTableComponent
                      data={dataFeedLean}
                      page={page}
                      countPerPage={countPerPage}
                      columns={columns}
                      setPage={setPage}
                  />
              </div>
              {isOpen && (
                <div className="col-xl-6">
                  {/* Content setelah diklik */}
                  <img src={'data:image/jpg;base64,' + imageDwi} style={{ width: '100%' }} alt="cover" />
                </div>
              )}
        </div>
    </ModalDetailComponent>
        
  )
}

export default DetailLaporanLean